import { BALANCE, type Transition } from '@2k48/shared';
import { feedback } from '../platform/feedback';
import { dur } from './motion';

/**
 * Attach semantic audio/haptic beats to the same GSAP timeline that renders a
 * board batch. The timeline remains visual-only: these callbacks never enable
 * input, advance phases or mutate rules state.
 */
export function attachTransitionFeedback(
  timeline: GSAPTimeline,
  transitions: readonly Transition[],
): void {
  const stages = [...new Set(transitions.map((transition) => transition.stage ?? 0))].sort(
    (left, right) => left - right,
  );

  for (const stage of stages) {
    const batch = transitions.filter((transition) => (transition.stage ?? 0) === stage);
    const label = `stage-${stage}`;

    if (batch.some((transition) => transition.kind === 'move' || transition.kind === 'merge')) {
      timeline.call(() => feedback.emit('game.slide'), undefined, label);
    }

    if (batch.some((transition) => transition.kind === 'merge')) {
      timeline.call(
        () => feedback.emit('game.merge'),
        undefined,
        `${label}+=${dur(BALANCE.motion.moveSec)}`,
      );
    }

    if (batch.some((transition) => transition.kind === 'spawn')) {
      timeline.call(() => feedback.emit('game.spawn'), undefined, label);
    }
  }
}
